/* eslint-disable */
import ItemBase from "./ItemBase";

class ItemOsmMapOther extends ItemBase {
  constructor(scene, mesh) {
    super(scene, mesh);

    this.mesh.position = 50;
    this.mesh.scaling.y = 1;
    this.mesh.material.alpha = 0;

    //add animation
    mesh.animations = [];
    mesh.animations.push(this.createMoveAnimation());

    setTimeout(() => {
      scene.beginAnimation(mesh, 0, 30, false);
      this.mesh.material.alpha = 1;
    }, Math.floor(Math.random() * 5000));
  }

  //create animation
  createMoveAnimation() {
    let keys = [];

    keys.push({
      frame: 0,
      value: 50
    });

    keys.push({
      frame: 30,
      value: 0
    });

    let animationBox = new BABYLON.Animation(
      this.mesh.id,
      "position.y",
      30,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_RELATIVE
    );

    animationBox.setKeys(keys);

    //easing
    let easingFunction = new BABYLON.CircleEase();
    easingFunction.setEasingMode(BABYLON.EasingFunction.EASEIN);
    animationBox.setEasingFunction(easingFunction);

    return animationBox;
  }
}
export default ItemOsmMapOther;
